import { Field, Form, Formik } from "formik";
import React from "react";
import Select from "react-select";
import Toggle from 'react-toggle'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import ReactTable from "react-table";
import "react-table/react-table.css";

import ButtonPrimary from "../Buttons/ButtonPrimary";
import { useEffect } from "react";
import { useRef } from "react";
import DemitidoOverlay from "../Table/Overlay/DemitidoOverlay";

const DOCUMENT_TYPES = [
  { label: 'Contrato', value: 'CON' },
  { label: 'Terceiro', value: 'EMP' },
  { label: 'Funcionários', value: 'FUN' },
]

const BaixarDocumentosModal = ({ visible = false, onSubmit, funcionarios = [] }) => {
  const form = useRef(null);

  useEffect(() => {
    if (visible && form.current && funcionarios.length) {
      form.current.resetForm();
    }
  }, [visible, funcionarios]);

  return (
    <div className="pb-5 pt-3">
      <div className="row mx-0 d-flex align-items-center justify-content-center">
        <div className="col-12 px-4">
          <p>Quais arquivos deseja exportar em um arquivo Zip?</p>
          <p>
            <b>Atenção:</b> a geração pode levar alguns segundos, acompanhe a
            mesma na Central de Exportação.
          </p>
        </div>
      </div>
      <div className="row mx-0 d-flex align-items-center justify-content-center">
        <div className="col-12 px-4">
          <div className="card">
            <div className="card-body px-2">
              <Formik
                ref={form}
                initialValues={{
                  apenasAprovados: false,
                  tiposDocumento: DOCUMENT_TYPES.map((type) => type.value),
                  funcionarios: funcionarios.map((f) => f.idFuncionario)
                }}
                validate={(values) => {
                  if (values.tiposDocumento.length === 0) {
                    return { tiposDocumento: 'Selecione pelo menos um tipo de documento.' };
                  }
                }}
                onSubmit={(values) => onSubmit(values)}
                render={({ isSubmitting, errors, handleSubmit, setFieldValue }) => (
                  <Form onSubmit={handleSubmit} className="mx-auto">
                    <div className="my-3">
                      <Field name="apenasAprovados">
                        {({ field }) => (
                          <div className="d-flex align-items-center justify-content-center gap-2 my-2 pointer">
                            <input
                              {...field}
                              className="mr-1 cursor-pointer"
                              type="radio"
                              id="all-documents"
                              value={!field.value}
                              defaultChecked={!field.value}
                              onChange={() => setFieldValue("apenasAprovados", false)}
                            />
                            <label
                              htmlFor="all-documents"
                              className="h6 d-flex align-items-center cursor-pointer"
                            >
                              Exportar Todos os Documentos
                            </label>
                          </div>
                        )}
                      </Field>
                      <Field name="apenasAprovados">
                        {({ field }) => (
                          <div className="d-flex align-items-center justify-content-center gap-2 my-2 pointer">
                            <input
                              {...field}
                              className="mr-1 cursor-pointer"
                              type="radio"
                              id="approved-documents"
                              value={field.value}
                              defaultChecked={field.value}
                              onChange={() => setFieldValue("apenasAprovados", true)}
                            />
                            <label
                              htmlFor="approved-documents"
                              className="h6 d-flex align-items-center cursor-pointer"
                            >
                              Exportar Apenas Aprovados
                            </label>
                          </div>
                        )}
                      </Field>
                      <div className="d-flex flex-column align-items-center justify-content-center gap-2 my-2 pointer">
                        <label htmlFor="documentos" className="w-100">
                          Tipos de Documento
                        </label>
                        <Field name="tiposDocumento">
                          {({ field }) => (
                            <>
                              <Select
                                {...field}
                                isMulti
                                id="documentos"
                                className="w-100"
                                placeholder="Selecione os tipos de documentos"
                                options={DOCUMENT_TYPES}
                                value={DOCUMENT_TYPES.filter((type) => field.value.includes(type.value))}
                                onChange={(options) => setFieldValue("tiposDocumento", options.map((option) => option.value))}
                                styles={{
                                  menu: (base) => ({
                                    ...base,
                                    zIndex: 100,
                                  }),
                                }}
                                theme={(theme) => ({
                                  ...theme,
                                  colors: {
                                    ...theme.colors,
                                    primary50: "#ebebeb",
                                    primary25: "#ebebeb",
                                    primary: "#ff5818",
                                  },
                                })}
                              />
                              {errors.tiposDocumento && (
                                <div className="invalid-feedback">{errors.tiposDocumento}</div>
                              )}
                            </>
                          )}
                        </Field>
                      </div>
                      {!!funcionarios?.length && (
                        <>
                          <hr />
                          <h5>Funcionários</h5>
                          <Field name="funcionarios">
                            {({ field }) => (
                              <ReactTable
                                columns={[
                                  {
                                    Header: "Nome",
                                    accessor: "nome",
                                    headerClassName: 'nome-placeholder documentos-filtro',
                                    className: "font-weight-600 text-uppercase",
                                    filterable: true,
                                    Cell: (props) => {
                                      const { value } = field;
                                      const id = props.original.idFuncionario;
                                      return (
                                        <div className="d-flex align-items-center">
                                          <Toggle
                                            checked={value.includes(id)}
                                            onChange={() => setFieldValue("funcionarios", value.includes(id) ? value.filter((f) => f !== id) : [...value, id])}
                                            className="mr-3"
                                          />
                                          {' ' + props.original.nome + ' '}
                                          <DemitidoOverlay funcionario={props.original} />
                                        </div>
                                      );
                                    },
                                  },
                                ]}
                                multiSort={false}
                                data={funcionarios}
                                previousText={<FontAwesomeIcon icon="chevron-left" />}
                                nextText={<FontAwesomeIcon icon="chevron-right" />}
                                resizable={false}
                                loadingText="Carregando..."
                                noDataText="Nenhum funcionário encontrado"
                                pageText="Página"
                                ofText="de"
                                rowsText="linhas"
                                pageJumpText="ir para a página"
                                rowsSelectorText="linhas por página"
                                pageSizeOptions={[5, 10, 20, 50]}
                                defaultPageSize={10}
                                minRows={0}
                                sortable={false}
                                className="-highlight"
                                defaultFilterMethod={(filter, row, column) => {
                                  const id = filter.pivotId || filter.id
                                  return row[id] !== undefined ? String(row[id]).toUpperCase().startsWith(filter.value.toUpperCase()) : true
                                }}
                              />
                            )}
                          </Field>
                        </>
                      )}
                    </div>
                    <div className="d-flex justify-content-center gap-1 w-full mt-4">
                      <ButtonPrimary
                        className="btn-confirm swal2-styled"
                        type="submit"
                        disabled={isSubmitting}
                      >
                        Confirmar
                      </ButtonPrimary>
                    </div>
                  </Form>
                )}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BaixarDocumentosModal;
